
import {throwError as observableThrowError, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Router} from '@angular/router';
import {catchError} from 'rxjs/operators';
import {AuthService} from "../services/auth.service";
import {AlertService} from "../services/alert.service";
import {LoadingService} from "../services/loading.service";

export const SILENT_HTTP_ERRORS = new HttpContextToken<boolean>(() => false);

export enum ErrorStatus {
    Success = 200,
    Unauthorized = 401,
    SubscriptionRequired = 402,
    NoAccessToAction = 403,
    ERROR = 500,
    USER_ERROR = 400
}

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private auth: AuthService,
        private alertService: AlertService,
        private loadingService: LoadingService
    ) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.overrideRequest(req, next);
    }

    private overrideRequest(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    if (req.context.get(SILENT_HTTP_ERRORS)) {
                        if (err.status === ErrorStatus.Unauthorized) {
                            this.auth.logout();
                        }

                        return observableThrowError(err);
                    }

                    this.loadingService.hideLoading();
                    if (err.status === ErrorStatus.Unauthorized) {
                       this.auth.logout();
                    } else if ([ErrorStatus.USER_ERROR, 404, ErrorStatus.ERROR, 422, 0].includes(err.status)) {
                        try {
                            let message = !err.error.errors || !Object.keys(err.error.errors).length
                              ? err.error.message
                              : err.error.errors[Object.keys(err.error.errors)[0]][0];

                            if (!message) {
                                message = err.error[Object.keys(err.error)[0]][0];
                            }


                            this.alertService.showError(message);
                        } catch (e) {
                            this.alertService.showGeneralError();
                        }
                    } else if (err.status === ErrorStatus.SubscriptionRequired) {
                        this.alertService.showError(err.error?.message || 'Moduł niedostępny w tym abonamencie.');
                    } else if (err.status === ErrorStatus.NoAccessToAction) {
                        this.alertService.showError('Nie masz uprawnień do wykonania tej operacji!');
                    }

                    return observableThrowError(err);
                })
            );
    }
}

export let HttpErrorInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorInterceptor,
    multi: true
};
